import React from "react";
import axios from "axios";
import { useParams } from 'react-router-dom';
import { notifications } from '@mantine/notifications';
import { Text, Box, Divider, Radio, Checkbox, Button } from '@mantine/core';
import { Carousel } from '@mantine/carousel';

import { useLoginContext } from "../../context/loginContext";
import { BE_API_THREE, utils, ROOT_BASE_URL } from "../../utils/globalVariables";
import { safeValue } from "../../utils/globalFunctions";

import ModalResponse from "../../components/general/ModalResponse";
import ModalTakeAction from "../../components/general/ModalTakeAction";
import PaperWrapper from "../../components/utilities/PaperWrapper";

const SudahSerahTerimaBuatNota = ({
  stateData,
  fnRefreshIndex,
  fnCloseDrawer,
  fnSuccessSubmit,
  fnClickPhoto
}) => {

  const mountedRef = React.useRef(true);
  const { URI1 } = useParams();
  const { loginContext, handleSetLoginContext } = useLoginContext();

  const heightImage = 150;

  const notificationId = React.useRef({
    errorGetData: 'sudahSerahTerimaBuatNota-1',
    successBuatNota: 'sudahSerahTerimaBuatNota-2',
    errorBuatNota: 'sudahSerahTerimaBuatNota-3',
  })

  const [data, setData] = React.useState({
    data: [],
    dataFlag: 'idle',
    dataInitLoading: false,

    customerId: '',
    itemSelectedIndex: '',
    itemSelectedBarangCategoryId: '',
    itemSelectedName: '',
    itemSelectedKeluhan: '',
    itemSelectedKelengkapan: [],
    itemSelectedFoto: [],

    notaModal: false,
    notaSubmitLoading: false,

    modalResponse: {
      show: false,
      type: utils.modalResponse.warning,
      hideOnClickOutSide: false,
      content: ''
    }
  });

  React.useEffect(() => {
    return () => {
      mountedRef.current = false;
    }
  }, [])

  React.useEffect(() => {
    if (URI1) {

      setData(d => ({ ...d, dataInitLoading: true }))

      const formDT = new FormData();
      const formDTHeader = { 'Content-Type': 'application/json' }

      formDT.append('json_token', loginContext.syswebapp);
      formDT.append('flag_all', utils.flagAll);
      formDT.append('trx_id', URI1);
      formDT.append('current_step', stateData.utilsRef.currentStep);
      formDT.append('is_cancel', stateData.utilsRef.isCancel);

      axios({
        method: 'post',
        url: BE_API_THREE + '/data_init_delivery_penjemputan__by_penjemputan_id_sedang_jemput',
        data: formDT,
        headers: formDTHeader,
      }).then((response) => {
        if (!mountedRef.current) return null;

        setData(d => ({ ...d, dataInitLoading: false }));

        if (response.data.flag_status === 'isset') {
          setData(d => ({
            ...d,
            data: response.data.data,
            dataFlag: (Array.isArray(response.data.data) && (response.data.data.length > 0)) ? true : false,
          }))
        }

        if (response.data.flag_status === 'error') {
          notifications.show({
            id: notificationId.current.errorGetData,
            title: utils.notification.warning.caption,
            message: response.data.pesan,
            color: utils.notification.warning.color,
            icon: utils.notification.warning.icon,
            withBorder: true,
            autoClose: true,
          })
        }

        if (response.data.flag_status === 'no-data') {
          setData(d => ({
            ...d,
            modalResponse: {
              ...d.modalResponse,
              type: utils.modalResponse.warning,
              hideOnClickOutSide: true,
              content: 'Data tidak ditemukan.',
              show: true
            }
          }))
        }

        if (response.data.flag_status === 'invalid-json-token') {
          handleSetLoginContext(null);
        }

        if (response.data.flag_status === 'user-inactive') {
          handleSetLoginContext(null);
        }
      }).catch(error => {
        if (!mountedRef.current) return null;

        setData(d => ({
          ...d,
          dataInitLoading: false
        }))

        notifications.show({
          id: notificationId.current.errorGetData,
          title: utils.notification.warning.caption,
          message: error.message,
          color: utils.notification.warning.color,
          icon: utils.notification.warning.icon,
          withBorder: true,
          autoClose: true,
        })
      })
    }
  }, [handleSetLoginContext, loginContext, loginContext.syswebapp, URI1, stateData.utilsRef.currentStep, stateData.utilsRef.isCancel])

  const handleSetKelengkapan = (val) => {
    const existingObject = data.itemSelectedKelengkapan.find(obj => obj.id === val.id);

    if (existingObject) {
      setData(d => ({
        ...d,
        itemSelectedKelengkapan: d.itemSelectedKelengkapan.filter(obj => obj.id !== val.id)
      }))
    } else {
      setData(d => ({
        ...d,
        itemSelectedKelengkapan: [...d.itemSelectedKelengkapan, val]
      }))
    }
  }

  const handleSetFoto = (val) => {
    const existingObject = data.itemSelectedFoto.find(obj => obj.id === val.id);

    if (existingObject) {
      setData(d => ({
        ...d,
        itemSelectedFoto: d.itemSelectedFoto.filter(obj => obj.id !== val.id)
      }))
    } else {
      setData(d => ({
        ...d,
        itemSelectedFoto: [...d.itemSelectedFoto, val]
      }))
    }
  }

  const handleBuatNota = () => {
    if (!data.itemSelectedName) {
      setData(d => ({
        ...d,
        notaModal: false,
        modalResponse: {
          ...d.modalResponse,
          type: utils.modalResponse.warning,
          hideOnClickOutSide: true,
          content: 'Pilih barang yang akan dibuatkan nota.',
          show: true
        }
      }))
    } else {
      setData(d => ({ ...d, notaSubmitLoading: true }));

      const formDT = new FormData();
      const formDTHeader = { 'Content-Type': 'application/json' }

      formDT.append('json_token', loginContext.syswebapp);
      // formDT.append('flag_all', utils.flagAll);
      formDT.append('trx_id', URI1);
      formDT.append('customer_id', data.customerId);
      formDT.append('current_step', stateData.utilsRef.currentStep);
      formDT.append('is_cancel', stateData.utilsRef.isCancel);
      formDT.append('project_process_nota', utils.projectProcess.nota.value);
      // formDT.append('project_process_sudah_diambil', utils.projectProcess.sudah_diambil.value);
      formDT.append('alamat_selector', JSON.stringify(utils.alamatSelector));

      formDT.append('barang_category_id', data.itemSelectedBarangCategoryId);
      formDT.append('nama_barang', data.itemSelectedName);
      formDT.append('keluhan', data.itemSelectedKeluhan);
      formDT.append('kelengkapan', JSON.stringify(data.itemSelectedKelengkapan));
      formDT.append('foto', JSON.stringify(data.itemSelectedFoto));

      axios({
        method: 'post',
        url: BE_API_THREE + '/buat_nota_from_delivery_penjemputan',
        data: formDT,
        headers: formDTHeader,
      }).then((response) => {
        if (!mountedRef.current) return null;

        setData(d => ({ ...d, notaSubmitLoading: false, notaModal: false }));

        if (response.data.flag_status === 'isset') {
          // setData(d => ({
          //     ...d,
          //     itemSelectedBarangCategoryId: '',
          //     itemSelectedName: '',
          //     itemSelectedKeluhan: '',
          //     itemSelectedIndex: '',
          //     itemSelectedKelengkapan: [],
          //     itemSelectedFoto: []
          // }));

          // notifications.show({
          //     id: notificationId.current.successBuatNota,
          //     title: utils.notification.success.caption,
          //     message: 'Berhasil Submit Data',
          //     color: utils.notification.success.color,
          //     icon: utils.notification.success.icon,
          //     withBorder: true,
          //     autoClose: true,
          // })

          // fnCloseDrawer();
          fnSuccessSubmit(data.customerId);
        }

        if (response.data.flag_status === 'unfinished-nota') {
          setData(d => ({
            ...d,
            modalResponse: {
              ...d.modalResponse,
              type: utils.modalResponse.warning,
              hideOnClickOutSide: true,
              content: 'Nota tidak dapat dibuat karena terdapat nota yang belum diselesaikan untuk customer ini. Selesaikan nota terlebih dahulu.',
              show: true
            }
          }))
        }

        if (response.data.flag_status === 'not-complete-data') {
          setData(d => ({
            ...d,
            modalResponse: {
              ...d.modalResponse,
              type: utils.modalResponse.warning,
              hideOnClickOutSide: true,
              content: response.data.message,
              show: true
            }
          }))
        }

        if (response.data.flag_status === 'error') {
          notifications.show({
            id: notificationId.current.errorBuatNota,
            title: utils.notification.warning.caption,
            message: response.data.pesan,
            color: utils.notification.warning.color,
            icon: utils.notification.warning.icon,
            withBorder: true,
            autoClose: true,
          })
        }

        if (response.data.flag_status === 'no-data') {
          fnCloseDrawer();

          setData(d => ({
            ...d,
            modalResponse: {
              ...d.modalResponse,
              type: utils.modalResponse.warning,
              hideOnClickOutSide: true,
              content: 'Data tidak ditemukan.',
              show: true
            }
          }))
        }

        if (response.data.flag_status === 'invalid-json-token') {
          handleSetLoginContext(null);
        }

        if (response.data.flag_status === 'user-inactive') {
          handleSetLoginContext(null);
        }
      }).catch(error => {
        if (!mountedRef.current) return null;

        setData(d => ({ ...d, notaSubmitLoading: false, notaModal: false }));

        notifications.show({
          id: notificationId.current.errorBuatNota,
          title: utils.notification.warning.caption,
          message: error.message,
          color: utils.notification.warning.color,
          icon: utils.notification.warning.icon,
          withBorder: true,
          autoClose: true,
        })
      })
    }
  }

  return (
    <React.Fragment>
      {data.dataInitLoading &&
        <PaperWrapper stateMT="0">
          <Text size='sm' color="dimmed">Loading Data..</Text>
        </PaperWrapper>
      }

      {!data.dataInitLoading && Array.isArray(data.data) && (data.data.length <= 0) &&
        <PaperWrapper stateMT="0">
          <Text size='sm' color="dimmed">No Data</Text>
        </PaperWrapper>
      }

      {!data.dataInitLoading && Array.isArray(data.data) && (data.data.length > 0) && Object.keys(data.data).map((keyD, indexD) => {
        return (
          <React.Fragment key={keyD}>
            {Array.isArray(data.data[keyD].barang) && Object.keys(data.data[keyD].barang).map((keyB, indexB) => {
              return (
                <Box
                  key={keyB}

                  onClick={(e) => {
                    e.preventDefault()
                  }}
                >
                  <Radio
                    name="asds"
                    checked={data.itemSelectedIndex === indexB}
                    onClick={(e) => {
                      e.stopPropagation()
                    }}

                    onChange={() => setData(d => ({
                      ...d,
                      itemSelectedIndex: indexB,

                      itemSelectedBarangCategoryId: data.data[keyD].barang[keyB].barang_category_id,
                      itemSelectedName: data.data[keyD].barang[keyB].delivery_jemput_barang_actual_name,
                      itemSelectedKeluhan: data.data[keyD].barang[keyB].delivery_jemput_barang_actual_keluhan,

                      customerId: data.data[keyD].customer_id,
                      itemSelectedKelengkapan: [],
                      itemSelectedFoto: []
                    }))}

                    label={
                      <React.Fragment>
                        <Text
                          fw='bold'
                          sx={(tema) => ({
                            lineHeight: 1,
                            color: tema.colorScheme === 'light' ? tema.colors.gray[7] : tema.colors.dark[0]
                          })}
                          mb='.5rem'
                          onClick={(e) => {
                            e.stopPropagation()
                          }}
                        >
                          {data.data[keyD].barang[keyB].delivery_jemput_barang_actual_name}
                        </Text>

                        <Text size='sm'>
                          Kategori : {safeValue(data.data[keyD].barang[keyB].barang_category_name, '[Kategori Barang]')}
                        </Text>

                        <Text size='sm'>
                          Keluhan : {safeValue(data.data[keyD].barang[keyB].delivery_jemput_barang_actual_keluhan, ' - ')}
                        </Text>

                        <Text size='sm'>
                          Kelengkapan :
                        </Text>

                        <Box mb='sm'>
                          {(Array.isArray(data.data[keyD].barang[keyB].kelengkapan) && (data.data[keyD].barang[keyB].kelengkapan.length > 0)) ? Object.keys(data.data[keyD].barang[keyB].kelengkapan).map((keyKL, indexKL) => {
                            return (
                              <Checkbox
                                key={keyKL}
                                size='sm'
                                mt='xs'
                                disabled={data.itemSelectedIndex !== indexB}
                                label={data.data[keyD].barang[keyB].kelengkapan[keyKL].delivery_jemput_kelengkapan_actual_name}

                                onClick={(e) => {
                                  e.stopPropagation()
                                }}

                                checked={data.itemSelectedIndex !== indexB ? false : (data.itemSelectedKelengkapan.map(obj => obj.id).includes(data.data[keyD].barang[keyB].kelengkapan[keyKL].delivery_jemput_kelengkapan_actual_id) ? true : false)}

                                onChange={(e) => {
                                  handleSetKelengkapan({
                                    id: data.data[keyD].barang[keyB].kelengkapan[keyKL].delivery_jemput_kelengkapan_actual_id,
                                    name: data.data[keyD].barang[keyB].kelengkapan[keyKL].delivery_jemput_kelengkapan_actual_name
                                  });
                                }}
                              />
                            )
                          })
                            :
                            <Text size='sm' color="dimmed" mt='xs'>
                              Tidak ada kelengkapan
                            </Text>
                          }
                        </Box>

                        <Box>
                          {(Array.isArray(data.data[keyD].barang[keyB].foto) && (data.data[keyD].barang[keyB].foto.length > 0)) ?
                            <Box mt='lg'>
                              <Text size='sm'>
                                Foto Barang {Array.isArray(data.data[keyD].barang[keyB].foto) ? `(${data.data[keyD].barang[keyB].foto.length})` : '(0)'}
                              </Text>

                              <Carousel
                                withIndicators={false}
                                withControls={Array.isArray(data.data[keyD].barang[keyB].foto) && (data.data[keyD].barang[keyB].foto.length > 1)}
                                height={heightImage}
                                slideSize="33.333333%"
                                slideGap="xs"
                                loop
                                align="start"
                                mt='sm'
                              >
                                {Object.keys(data.data[keyD].barang[keyB].foto).map((keyF, indexF) => {
                                  return (
                                    <Carousel.Slide key={keyF}>
                                      <Box
                                        sx={{
                                          position: 'relative',
                                          height: heightImage + 'px'
                                        }}
                                      >
                                        <img
                                          alt={`foto-barang-${indexF}`}
                                          src={`${ROOT_BASE_URL}${data.data[keyD].barang[keyB].foto[keyF].delivery_jemput_barang_foto_actual_nama}`}
                                          style={{
                                            width: '100%',
                                            height: '100%',
                                            objectFit: 'cover'
                                          }}

                                          onClick={() => fnClickPhoto({
                                            // image: `${ROOT_BASE_URL}${data.data[keyD].barang[keyB].foto[keyF].delivery_jemput_barang_foto_actual_nama}`,
                                            images: data.data[keyD].barang[keyB].foto,
                                            title: 'Foto Barang',
                                            index: keyF,
                                            fieldName: 'delivery_jemput_barang_foto_actual_nama'
                                          })}
                                        />

                                        <Box
                                          sx={(tema) => ({
                                            // height: '30px',
                                            backgroundColor: tema.fn.rgba('#404040', 0.75),
                                            position: 'absolute',
                                            bottom: 0,
                                            left: 0,
                                            right: 0,
                                            padding: '6px',
                                            // display: 'flex',
                                            // justifyContent: 'left',
                                            // alignItems: 'center',
                                            cursor: 'pointer'
                                          })}
                                        >
                                          <Checkbox
                                            size='sm'
                                            disabled={data.itemSelectedIndex !== indexB}
                                            label='Pilih'

                                            onClick={(e) => {
                                              e.stopPropagation()
                                            }}

                                            checked={data.itemSelectedIndex !== indexB ? false : (data.itemSelectedFoto.map(obj => obj.id).includes(data.data[keyD].barang[keyB].foto[keyF].delivery_jemput_barang_foto_actual_id) ? true : false)}

                                            onChange={(e) => {
                                              handleSetFoto({
                                                id: data.data[keyD].barang[keyB].foto[keyF].delivery_jemput_barang_foto_actual_id,
                                                name: data.data[keyD].barang[keyB].foto[keyF].delivery_jemput_barang_foto_actual_nama
                                              });
                                            }}
                                          />
                                        </Box>
                                      </Box>
                                    </Carousel.Slide>
                                  )
                                })}
                              </Carousel>
                            </Box>
                            :
                            <Text size='sm' color="dimmed" mt='sm'>
                              Tidak ada foto
                            </Text>
                          }
                        </Box>
                      </React.Fragment>
                    }
                  />

                  <Divider my='1rem' />
                </Box>
              )
            })}
          </React.Fragment>
        )
      })}

      <Box
        mt='1.5rem'
      >
        <Text
          color="dimmed"
          size='sm'
          mb='1rem'
        >
          Untuk membuat nota dari delivery penjemputan ini, pilih barang yang akan dibuatkan nota.
          Kelengkapan barang dan foto barang dapat dipilih atau pun tidak. Data barang, kelengkapan dan foto barang dapat Anda sesuaikan kembali pada proses selanjutnya (nota).
        </Text>

        <Button
          fullWidth
          color="blue"
          onClick={() => setData(d => ({
            ...d,
            notaModal: true
          }))}
        >
          Buat Nota
        </Button>
      </Box>

      <ModalResponse
        stateShow={data.modalResponse.show}
        fnHide={() => setData(d => ({
          ...d,
          modalResponse: {
            ...d.modalResponse,
            show: false
          }
        }))}

        stateHideOnClickOutSide={data.modalResponse.hideOnClickOutSide}
        stateType={data.modalResponse.type}
        stateContent={data.modalResponse.content}
      />

      <ModalTakeAction
        stateShow={data.notaModal}
        fnHide={() => setData(d => ({ ...d, notaModal: false }))}

        stateHideOnClickOutSide={true}
        stateTitle={String('Confirmation').toUpperCase()}
        stateOverlayZIndex={201}

        stateButtonClosePx='md'

        stateButtonActionCaption='Submit'
        stateButtonActionPx='xs'
        stateButtonActionColor="blue"
        stateButtonActionLoading={data.notaSubmitLoading}
        fnButtonAction={handleBuatNota}
      >
        <Text size='sm' color="dimmed">Buat Nota ?</Text>
      </ModalTakeAction>
    </React.Fragment>
  )
}

export default SudahSerahTerimaBuatNota;